import { type TextareaFieldValue } from '@gorilla/portal-shared/src/schemas';
import { type TextareaFieldDescriptor } from '@gorilla/portal-shared/src/types';
import { MarkdownTextarea } from '../MarkdownTextarea';

type TextareaFieldProps = {
  value: TextareaFieldValue;
  fieldDescriptor: TextareaFieldDescriptor;
  onChange: (value: TextareaFieldValue) => void;
  onShowPlaceholdersModalClick: () => void;
};

export function TextareaField({ value, fieldDescriptor, onChange, onShowPlaceholdersModalClick }: TextareaFieldProps) {
  return (
    <MarkdownTextarea
      rows={6}
      value={value}
      label={fieldDescriptor.title}
      onChange={onChange}
      fieldDescriptor={fieldDescriptor}
      onShowPlaceholdersModalClick={onShowPlaceholdersModalClick}
    />
  );
}
